import {svgIconWrapper} from '../svg-icon-wrapper';

import XSocial from './x-social-icon.svg';

// @ts-expect-error
function SvgComponent(props) {
    const validProps = Object.assign({}, props);
    delete validProps.styles;

    return <XSocial {...validProps} />;
}

SvgComponent.iconName = 'xSocial';

export const XSocialIcon = svgIconWrapper(SvgComponent);
